import { useSetRecoilState } from 'recoil'

import { manageProjectStore, ManageProjectStoreType } from './useManageProjectStore'
import * as RESServiceType from '../../services/web/types/responseWebServiceTypes'

const useManageProjectAction = () => {
    const setManageProjectStore = useSetRecoilState(manageProjectStore)

    const setState = (newState: Partial<ManageProjectStoreType>) => {
        setManageProjectStore((prevState) => ({
            ...prevState,
            ...newState,
        }))
    }

    const setProjectData = (param?: RESServiceType.GetProjectResultType) => {
        setManageProjectStore((prevState) => ({
            ...prevState,
            projectData: param,
        }))
    }
    const setDocumentTopic = (param: any) => {
        setManageProjectStore((prevState) => ({
            ...prevState,
            documentTopic: param,
        }))
    }
    const setParameterForSave = (param: any) => {
        setManageProjectStore((prevState) => ({
            ...prevState,
            parameterForSave: param,
        }))
    }
    const setUpdaterPage = (param: ManageProjectStoreType['currentPageUpdater']) => {
        setManageProjectStore((prevState) => ({
            ...prevState,
            currentPageUpdater: param,
        }))
    }
    const clearStore = () => {
        setManageProjectStore((prevState) => ({
            ...prevState,
            projectData: null,
            documentTopic: null,
            parameterForSave: null,
            currentPageUpdater: null,
        }))
    }
    return { setState, setProjectData, setDocumentTopic, setParameterForSave, clearStore, setUpdaterPage }
}

export default useManageProjectAction
